import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { TransferNumbersComponent } from "@onsip/web/features/accountSettings/transfer-numbers/transfer-numbers.component";
import { TransferNumbersRouterModule } from "@onsip/web/features/accountSettings/transfer-numbers/transfer-numbers-router.module";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { TableModule } from "@onsip/web/features/shared/components/table/onsip-table.module";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { MatButtonModule } from "@angular/material/button";
import { TransferNumbersModalComponent } from "@onsip/web/features/accountSettings/transfer-numbers/transfer-numbers-modal/transfer-numbers-modal.component";
import { MatDialogModule } from "@angular/material/dialog";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    TransferNumbersRouterModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatInputModule,
    ReactiveFormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCheckboxModule,
    TableModule,
    MatTableModule,
    MatSortModule,
    PipesModule,
    MatButtonModule,
    MatDialogModule,
    LoadingContainerComponent
  ],
  declarations: [TransferNumbersComponent, TransferNumbersModalComponent]
})
export class TransferNumbersModule {}
